import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { createToken, getHelpDesk } from "../../redux/helpdesk/helpdeskSlice";
import { getProfile } from "../../redux/profile/profileSlice";
import { fetchBugReports, reportBug } from "../../redux/bugs/bugSlice";
import HelpDeskTable from "./HelpDeskTable";
import DrawerContent from "./DrawerContent"; // Import the new component
import styles from "./HelpDesk.module.css";

const HelpDesk = () => {
  const [open, setOpen] = useState(false);
  const [formType, setFormType] = useState("helpTicket");
  const [multipleImages, setMultipleImages] = useState([]);

  const theme = useTheme();
  const dispatch = useDispatch();
  const helpdesk = useSelector((state) => state.helpdesk?.data);
  const helpdeskStatus = useSelector((state) => state.helpdesk?.status);
  const profile = useSelector((state) => state.profile?.data?.profile);

  console.log("helpdesk", helpdesk, profile);

  // Help Ticket Form
  const formik = useFormik({
    initialValues: {
      full_name: profile?.full_name || "",
      mobile_no: profile?.mobile_no || "",
      language: [],
      time_slot: "",
      module: [],
      page_name: "",
      subject: "",
      description: "",
    },
    validationSchema: Yup.object({
      module: Yup.array()
        .min(1, "Select at least one module")
        .required("Module is required"),
      page_name: Yup.string().required("Page name is required"),
      subject: Yup.string().required("Subject is required"),
      description: Yup.string().required("Description is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("customer_name", values?.full_name);
      formData.append("company_name", profile?.company_name);
      formData.append("description", values?.description);
      formData.append("language_preference", JSON.stringify(values?.language));
      formData.append(
        "facing_problem_in_module_name",
        JSON.stringify(values?.module)
      );
      formData.append("facing_problem_in_page_name", values?.page_name);
      formData.append("mobile", values?.mobile_no);
      formData.append("subject", values?.subject);

      for (const file of multipleImages) {
        formData.append("images", file);
      }

      dispatch(createToken(formData));
    },
  });

  // Bug Report Form
  const [bugData, setBugData] = useState({
    module_name: "",
    page_name: "",
    page_url: "",
    browser_name: "",
    comment: "",
    images: [],
  });

  const handleImageUploadForPublic = (event) => {
    const files = Array.from(event.target.files);
    setMultipleImages((prev) => [...prev, ...files]);
  };

  const handleImageUpload = (event) => {
    const files = event.target.files;
    const promises = [];
    for (let i = 0; i < files.length; i++) {
      promises.push(
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(files[i]);
        })
      );
    }

    Promise.all(promises)
      .then((base64Images) => {
        setBugData((prev) => ({
          ...prev,
          images: [...prev.images, ...base64Images],
        }));
      })
      .catch((err) => console.error("Image Upload Error:", err));
  };

  const handleBugSubmit = (e) => {
    e.preventDefault();
    dispatch(reportBug(bugData));
    handleClose();
    setBugData({
      module_name: "",
      page_name: "",
      page_url: "",
      browser_name: "",
      comment: "",
      images: [],
    });
  };

  const handleBugChange = (e) => {
    setBugData({ ...bugData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    dispatch(getHelpDesk());
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    if (helpdeskStatus === "create_helpdesk_succeeded") {
      dispatch(getHelpDesk());
      handleClose();
      formik.resetForm({
        values: {
          subject: "",
          description: "",
        },
      });
    }
    dispatch(fetchBugReports());
  }, [helpdeskStatus, dispatch]);

  useEffect(() => {
    if (profile) {
      formik.setFieldValue("full_name", profile?.full_name || "");
      formik.setFieldValue("mobile_no", profile?.mobile_no || "");
    }
  }, [profile]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box className={styles.helpdesk_structures}>
        <Box className={styles.header_section} sx={{ borderRadius: "3px" }}>
          <Box>
            <Typography sx={{ fontSize: "25px !important" }}>
              <b>100%</b>
            </Typography>
            <Typography>Service Satisfaction by our expert staff.</Typography>
          </Box>
          <Box>
            <span onClick={handleClickOpen}>Raise Ticket</span>
          </Box>
        </Box>
        <HelpDeskTable helpdesk={helpdesk?.results} />
      </Box>

      {/* Offcanvas Drawer */}
      <Offcanvas
        show={open}
        onHide={handleClose}
        placement="end"
        scroll={false}
        backdrop={false}
        style={{
          border: "none",
          marginTop: "65px",
          width: "60%",
          boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
          backgroundColor: "#fff",
        }}
      >
        <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
          <DrawerContent
            formType={formType}
            setFormType={setFormType}
            formik={formik}
            multipleImages={multipleImages}
            setMultipleImages={setMultipleImages}
            bugData={bugData}
            setBugData={setBugData}
            handleImageUploadForPublic={handleImageUploadForPublic}
            handleImageUpload={handleImageUpload}
            handleBugSubmit={handleBugSubmit}
            handleBugChange={handleBugChange}
            handleClose={handleClose}
            helpdeskStatus={helpdeskStatus}
            profile={profile}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default HelpDesk;
